<template>
    <div class="worldcup--general-section style-3">
        <a class="back" @click="ClickHideComponent" data-toggle="modal" href="javascript:void(0)">
            <img src="/assets/img/icon-back.svg" alt="back"/>
        </a>
        <b-tabs class="tab-modal">
            <b-tab title="Vòng quay World Cup" active>
                <div class="worldcup--box-tab">
                    <Prize />
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import Prize from '~/components/event/worldcup/tabs/prize.vue';

export default {
    components: {
        Prize
    },
    methods: {
        ClickHideComponent() {
            this.$emit('hideComponent');
        }
    }
};
</script>
